import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Container from 'components/Container';
import Sidebar from 'components/Sidebar';
import Topbar from 'components/Topbar';
import { Outlet, useLocation } from 'react-router';
import { StudentContextProvider } from 'context/StudentContext';

interface PropTypes {
  navBarItems: Array<NavItem | NavDropDown>;
  // colorInvert?: boolean;
  // bgcolor?: string;
  // permanentSidebar?: boolean;
  // children: ReactNode;
}

export function StudentLayout({ navBarItems = [] }: PropTypes): JSX.Element {
  const bgcolor = 'transparent';
  const permanentSidebar = false;
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const { pathname } = useLocation();
  const invertNavbarColor = ['/about'].includes(pathname.toLowerCase());

  const [openSidebar, setOpenSidebar] = useState(false);

  console.log('Student Navbar Items:', navBarItems);

  // effect to scroll to top when the route changes
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log(pathname);
  }, [pathname]);

  // const handleSidebarOpen = (): void => {
  //   setOpenSidebar(true);
  // };

  const handleSidebarClose = (): void => {
    setOpenSidebar(false);
  };

  const open = isMd && !permanentSidebar ? false : openSidebar;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return (
    <StudentContextProvider>
      <Box>
        <AppBar
          position={'sticky'}
          sx={{
            top: 0,
            backgroundColor: trigger ? theme.palette.background.paper : bgcolor,
          }}
          elevation={trigger ? 1 : 0}
        >
          <Container paddingY={1}>
            <Topbar
              permanentSidebar={permanentSidebar}
              toggleSidebar={() => setOpenSidebar((prevState) => !prevState)}
              navItems={navBarItems}
              colorInvert={trigger ? false : invertNavbarColor}
            />
          </Container>
        </AppBar>
        <Sidebar
          onClose={handleSidebarClose}
          open={open}
          variant={permanentSidebar && isMd ? 'persistent' : 'temporary'}
          navItems={navBarItems}
        >
          <main>
            <Outlet />
            <Divider />
          </main>
          {/* <Container paddingY={0}>
            <Footer />
          </Container> */}
        </Sidebar>

      </Box>
    </StudentContextProvider>
  );
}

export default StudentLayout;
